import { useContext } from "react";
import DataContext from "../contexts/dataContext";

export const useLocalStorage = (key) => {
  const { setScribbles } = useContext(DataContext);

  const isBrowser = typeof window !== "undefined" && typeof window.localStorage !== "undefined";

  const addScribble = (value) => {
    if (!isBrowser) return;   // Stop when not in browser

    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      throw new Error("Scribble not added to storage.");
    }
  };

  const removeScribble = (key, scribbleID) => {
    if (!isBrowser) return;   // Stop when not in browser

    const stored = window.localStorage.getItem(key);
    if (!stored) return;      // Nothing to remove

    const arr = JSON.parse(stored);
    const newArr = arr.filter(item => item.scribbleID !== scribbleID);

    localStorage.setItem(key, JSON.stringify(newArr))
    setScribbles(newArr)
  };

  return { addScribble, removeScribble };
};